import { render, staticRenderFns } from "./InternalButton.vue?vue&type=template&id=bb424c66&"
import script from "./InternalButton.vue?vue&type=script&lang=js&"
export * from "./InternalButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports